// extracted by mini-css-extract-plugin
export default {"price":"u6-z","onSale":"v6-z","msrpLabelPrice":"w6-z","msrpLabel":"x6-z","originalPrice":"y6-z","percentOff":"z6-z"};